import { Sparkle } from 'phosphor-react';
import NotificationBell from '../NotificationBell';

interface DashboardHeaderProps {
  userName: string | null;
  onAiChatClick: () => void;
}

export default function DashboardHeader({ userName, onAiChatClick }: DashboardHeaderProps) {
  return (
    <header className="px-5 pt-12 pb-2">
      <div className="max-w-lg mx-auto flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 flex items-center gap-1.5">
            Olá, {userName}
            <Sparkle className="w-5 h-5 text-blush-400" weight="fill" />
          </h1>
          <p className="text-sm text-nude-400 dark:text-gray-400 mt-1">
            Como está sua pele hoje?
          </p>
        </div>
        <div className="flex items-center gap-2">
          <NotificationBell />
          <button
            onClick={onAiChatClick}
            className="w-12 h-12 flex items-center justify-center rounded-full bg-white dark:bg-gray-800 shadow-soft dark:shadow-none border border-nude-100 dark:border-gray-700 text-blush-400 hover:text-blush-500 hover:shadow-glow-blush transition-[color,box-shadow] active:scale-[0.97]"
            aria-label="AutoCare Agent"
          >
            <Sparkle className="w-6 h-6" />
          </button>
        </div>
      </div>
    </header>
  );
}
